import Professional from "../../models/Professional";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";

export default class LoginForm implements FormBase {

    Login: FormFieldBase;
    Senha: FormFieldBase;

    constructor(Login: string, Senha: string) {
        this.Login = new FormFieldBase(Login, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.Senha = new FormFieldBase(Senha, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }


    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }
    }

    static NewInstance(): LoginForm {
        return new LoginForm("", "");
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Login":
                return this.Login
            case "Senha":
                return this.Senha

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet(): any {

        return {
            "usuario": this.Login.Value,
            "senha": this.Senha.Value,
        }
    }


    ValidateToGoNextStep(state?: any): string {
        throw new Error("Method not implemented.");
    }

    CallInsertOrUpdateApi(professional: Professional, customAttributes?: any): Promise<any> {
        throw new Error("Method not implemented.");
    }
}